import { useMemo } from "react";
import { Grid, useTheme } from "@mui/material";
import PropTypes from "prop-types";

DetailField.propTypes = {
  label: PropTypes.node,
  value: PropTypes.any,
  xs: PropTypes.number,
  md: PropTypes.number,
  labelXs: PropTypes.number,
  labelMd: PropTypes.number,
};

function formatBool(value) {
  if (typeof value === "boolean") {
    return value ? "Ano" : "-";
  } else {
    return value;
  }
}

function DetailField({ xs, md, label, value, labelXs, labelMd }) {
  const theme = useTheme();

  const formattedValue = useMemo(() => formatBool(value), [value]);
  const { xsWidthForLabel, mdWidthForLabel, xsWidthForValue, mdWidthForValue } = useMemo(getWidths, [labelXs, labelMd]);

  function getWidths() {
    const xsWidthForLabel = labelXs || 6;
    const mdWidthForLabel = labelMd || 6;

    const xsWidthForValue = 12 - xsWidthForLabel;
    const mdWidthForValue = 12 - mdWidthForLabel;

    return { xsWidthForLabel, mdWidthForLabel, xsWidthForValue, mdWidthForValue };
  }

  return (
    <Grid
      container
      spacing={1}
      size={{
        xs: xs || 12,
        md: md || 6,
      }}>
      <Grid
        sx={{ color: theme.palette.primary.main }}
        size={{
          xs: xsWidthForLabel,
          md: mdWidthForLabel,
        }}>
        {label}
      </Grid>
      <Grid
        size={{
          xs: xsWidthForValue,
          md: mdWidthForValue,
        }}>
        {formattedValue}
      </Grid>
    </Grid>
  );
}

export default DetailField;
